import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LOGOS } from "../../data/ventures";

export const Preloader = ({ onDone }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const iv = setInterval(() => {
      setCount((c) => {
        if (c >= 100) {
          clearInterval(iv);
          return 100;
        }
        const step = c < 60 ? 3 : c < 90 ? 2 : 1;
        return Math.min(c + step, 100);
      });
    }, 26);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    if (count >= 100) {
      const t = setTimeout(onDone, 350);
      return () => clearTimeout(t);
    }
  }, [count, onDone]);

  return (
    <motion.div
      data-testid="preloader"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#020617]"
    >
      <motion.img
        src={LOGOS.veerox}
        alt="Veerox"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="h-16 w-16 rounded-xl object-cover ring-1 ring-cyan-400/30 shadow-[0_0_30px_rgba(0,229,255,0.25)]"
      />
      <span className="reveal-mask mt-6">
        <motion.span
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="block font-display text-2xl font-extrabold tracking-[0.22em] text-white sm:text-3xl"
        >
          VEEROX <span className="text-gradient-cyan">GROUP</span>
        </motion.span>
      </span>
      <div className="mt-8 h-[2px] w-56 overflow-hidden rounded-full bg-white/10">
        <div
          className="h-full bg-gradient-to-r from-blue-500 to-cyan-400 shadow-[0_0_10px_rgba(0,229,255,0.8)]"
          style={{ width: `${count}%` }}
        />
      </div>
      <span className="mt-3 font-mono-tech text-xs text-cyan-400" data-testid="preloader-count">
        {count}%
      </span>
    </motion.div>
  );
};
